import { RegularBenefitVariant } from '../../../../../../typings'
import { SettingsProps } from '../../hooks/useGenericComponent'
import {
  FormulaEditor,
  FreeShippingEditor,
  GiftEditor,
  MaxPriceEditor,
  MaxShippingEditor,
  NominalEditor,
  NominalLoyaltyEditor,
  NominalShippingEditor,
  PercentualEditor,
  PercentualLoyaltyEditor,
  PercentualShippingEditor,
} from '../Variants'
import { PriceTableEditor } from '../Variants/PriceTable'

export const EDITOR_MAP: Record<
  RegularBenefitVariant,
  (props: SettingsProps) => JSX.Element
> = {
  [RegularBenefitVariant.Nominal]: NominalEditor,
  [RegularBenefitVariant.NominalShipping]: NominalShippingEditor,
  [RegularBenefitVariant.Percentual]: PercentualEditor,
  [RegularBenefitVariant.MaxPrice]: MaxPriceEditor,
  [RegularBenefitVariant.NominalLoyalty]: NominalLoyaltyEditor,
  [RegularBenefitVariant.PercentualShipping]: PercentualShippingEditor,
  [RegularBenefitVariant.FreeShipping]: FreeShippingEditor,
  [RegularBenefitVariant.MaxShipping]: MaxShippingEditor,
  [RegularBenefitVariant.Gift]: GiftEditor,
  [RegularBenefitVariant.PercentualLoyalty]: PercentualLoyaltyEditor,
  [RegularBenefitVariant.Formula]: FormulaEditor,
  [RegularBenefitVariant.PriceTable]: PriceTableEditor,
}
